import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'wf-district-report-container',
    templateUrl: './district-report-container.component.html',
    styleUrls: ['./district-report-container.component.css'],
    standalone: false
})
export class DistrictReportContainer implements OnInit {
  @Input() reportTitle: string = 'Report Title';
  @Input() loadError: string = '';
  @Output() onPrint: EventEmitter<void> = new EventEmitter<void>();
  printIcon = faPrint;

  constructor() {}

  ngOnInit(): void {}

  onPrintClicked(): void {
    this.onPrint.emit();
  }
}
